import {
    addUnit,
    deleteUnit,
    updateUnit,
    getUnits,
    getOneUnit,
    searchUnit,
    searchUnitForCurrentUser
} from '@/services/endpoints/unit'
import statuses from "@/constatnts/statuses";

export default {
    async addUnit({commit}, payload) {
        try {
            let res = await addUnit(payload);
            if (res) {
                return res.data
            } else {
                throw new Error('err')
            }
        } catch (err) {
            throw new Error(err)
        }
    },

    async deleteUnit({ commit }, payload) {
        try {
            let res = await deleteUnit(payload.unitsId)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async getUnits({commit},payload) {
        try {
            let res = await getUnits(payload);
            if (res) {
                commit('SET_UNITS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async getUnitToEdit({commit}, unitId) {
        try {
            let res = await getOneUnit(unitId);
            if (res) {
                commit('SET_UNIT_TO_EDIT', res.data)
                return res.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async updateUnit({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await updateUnit(payload.id, payload.payload);
            if (res) {
                // commit('SET_SERVICES', res.data)
                return res.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async searchUnit({commit}, payload) {
        try {
            let res = await searchUnit(payload);
            if (res) {
                 commit('SET_UNITS', res.data.data)
                 commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async searchUnitForCurrentUser({commit}, payload) {
        try {
            let res = await searchUnitForCurrentUser(payload);
            if (res) {
                commit('SET_UNITS_FOR_CURRENT_USER', res.data.data);
                commit('SET_UNITS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async searchActiveUnitForCurrentUser({commit},) {
        try {
            let res = await searchUnitForCurrentUser({status: 'active'});
            if (res) {
                commit('SET_UNITS_FOR_CURRENT_USER', res.data.data);
                commit('SET_UNITS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },
    async getOneUnit({commit}, unitId) {
        try {
            let res = await getOneUnit(unitId);
            if (res) {
                return res.data
            }
        } catch (err) {
            
            throw new Error(err)
        }
    },

    async getActiveUnits({ commit }) {
        try {
            let res = await searchUnit({status: statuses.ACTIVE});
            if(res) {
                commit('SET_UNITS', res.data.data)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}